import isBlank from '@/common/helpers/is-blank';

/**
 * Accepts raw string data either from manual input or a document paste and converts it
 * into a single array while returning a pre-formatted version for inline use.
 * @param {string} data
 * @returns {{inline: *, values: *}}
 */
export default function pasteToCommaString(data) {
    let inline = data;
    const values = data.split(/[\r\n,]+/gm)
        .filter(v => !isBlank(v))
        // trim otherwise the join will keep appending spaces
        .map(v => v.trim().replace(/\n/g, ''));
    if (/[\r\n]+/gm.test(data)) {
        // remove new lines from visible input
        inline = values.join(', ');
    }
    return {
        values,
        inline,
    };
}
